/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/


import App from "App";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// Soft UI Context Provider
import { ArgonControllerProvider } from "context";

// Auth Context Provider
import { AuthProvider } from "context/AuthContext";

// User Data Context Provider
import { UserDataProvider } from "context/UserDataContext";

// Language Context Provider
import { LanguageProvider } from "context/LanguageContext";
import AppGate from "components/AppGate";

// react-perfect-scrollbar component

// react-perfect-scrollbar styles
import "react-perfect-scrollbar/dist/css/styles.css";

// Desregistrar cualquier Service Worker existente
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister().then((success) => {
        if (success) {
        }
      });
    }
  });
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <ArgonControllerProvider>
      <AuthProvider>
        <UserDataProvider>
          <LanguageProvider>
            <AppGate>
              <App />
            </AppGate>
          </LanguageProvider>
        </UserDataProvider>
      </AuthProvider>
    </ArgonControllerProvider>
  </BrowserRouter>
);
